import React, { memo } from "react";
import { AvGroup } from "availity-reactstrap-validation";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { ValidationMessage } from "./ValidationMessage";

export const DisplayNameField = memo(
    ({
        t,
        isConsult,
        i18nextLng,
        advancedDisplayName,
        setAdvancedDisplayName,
        selectedLanguage,
        setIsEdited,
        setDisplay,
        setInputDisplay,
        inputDisplay,
        setIsAdvancedDisplayNameModalOpen,
        isAdvancedDisplayNameModalOpen,
        choiceMode,
    }: any) => (
        <AvGroup>
            <div className="d-flex justify-content-between mb-1">
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Display name")}
                </StyledLabel>
                <span
                    style={{
                        color: "blue",
                        cursor: "pointer",
                        textDecoration: "underline",
                        marginTop: "15px",
                    }}
                    role="button"
                    onClick={() =>
                        setIsAdvancedDisplayNameModalOpen(
                            !isAdvancedDisplayNameModalOpen
                        )
                    }
                    className={classnames("cmn_btn_advencedDisplayName", {
                        "not-allowed-icon__clz":
                            advancedDisplayName.languages[i18nextLng] === "" &&
                            choiceMode === "",
                    })}
                >
                    {t("Advanced")}
                </span>
            </div>

            <StyledTextInput
                className={classnames("mdr_inp_FRdisplayName", {
                    "pe-none__clz": isConsult,
                    input__clz: inputDisplay,
                })}
                autoComplete="off"
                name="choiceMode"
                onChange={(e: any) => {
                    setIsEdited(true);
                    setDisplay(e.target.value);
                    setInputDisplay(false);
                    setAdvancedDisplayName({
                        ...advancedDisplayName,
                        languages: {
                            ...advancedDisplayName.languages,
                            [selectedLanguage.value]: e.target.value,
                        },
                    });
                }}
                value={advancedDisplayName.languages[i18nextLng] ?? ""}
                placeholder={t("Write")}
            />

            <ValidationMessage
                condition={inputDisplay}
                text={t("Please enter a display name")}
            />
        </AvGroup>
    )
);
